import { whitepaper_bg } from "../../assets/images";
import styled from 'styled-components';

import CTASection from "../landing/landing_home/empower"
import Footer from "../Footer/footer"
import Navigation from "../navigation/header"
import CampusInsightsCard from "./discover";



const Whitepaper = () => {

  return (
    <>
      <Navigation />
      <HeroContainer>
        <ContentWrapper>
          <TextContent>
            <MainHeading>
             White Papers
            </MainHeading>
            <Subtitle>
              Redefining Student Support and Intelligence
            </Subtitle>
          </TextContent>
        </ContentWrapper>
      </HeroContainer>
      <CampusInsightsCard/>
      <CTASection />
      <Footer />
    </>
  );
};


export default Whitepaper;


const HeroContainer = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 420px;
  // width: 97.3%;
  overflow: hidden;
  position: relative;
  padding: 90px 20px 40px;

 background: 
    linear-gradient(
      rgba(0, 0, 0, 0.4) 0%,
      rgba(0, 0, 0, 0.55) 50%,
      rgba(0, 0, 0, 0.75) 100%
    ),
    url(${whitepaper_bg}) center / cover no-repeat;

  background-blend-mode: normal;

  > * {
    position: relative;
    z-index: 1;
  }

  @media (max-width: 640px) {
    padding: 20px 16px;
    height: 520px;
  }
`;


const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 989px;
  flex-direction: column;
  align-items: center;
  gap: 32px;

  @media (max-width: 991px) {
    max-width: 700px;
    gap: 28px;
  }

  @media (max-width: 640px) {
    gap: 24px;
  }
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

const MainHeading = styled.h1`
  width: 100%;
  color: #fff;
  text-align: center;
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.2);
  letter-spacing: -0.6px;
  font: 700 60px/70px 'Inter', sans-serif;
  margin: 0;

  @media (max-width: 991px) {
    font-size: 48px;
    line-height: 56px;
  }

  @media (max-width: 640px) {
    font-size: 32px;
    line-height: 40px;
    letter-spacing: -0.4px;
  }
`;

const Subtitle = styled.p`
  color: #fff;
  text-align: center;
  letter-spacing: -0.08px;
  font: 500 16px/160% 'Inter', sans-serif;
  margin: 0;

  @media (max-width: 640px) {
    font-size: 14px;
    line-height: 150%;
  }
`;